import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import CtaToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import ImageToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'
import VideoToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/VideoToolbarSection'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const TextMediaSettings = (settingsProps) => {
  const { props } = useNode((node) => ({
    customs: node.data.custom,
    props: node.data.props,
  }))

  const themeOpts = [
    { label: 'Bianco', value: '' },
    { label: 'Neutral 10', value: 'neutral10' },
  ]

  const sizeOpts = [
    { label: 'Large', value: 'lg' },
    { label: 'Small', value: 'sm' },
  ]

  const mediaPosOpts = [
    { label: 'Sinistra', value: 'left' },
    { label: 'Destra', value: 'right' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="refId"
          type="text"
          label="Anchor ID"
          defaultValue={defaultProps['refId']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="size"
          type="select"
          options={sizeOpts}
          label="Dimensione"
          defaultValue={defaultProps['size']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="mediaPos"
          type="select"
          options={mediaPosOpts}
          label="Posizione media"
          defaultValue={defaultProps['mediaPos']}
        />
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Tema"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      {!settingsProps.floating && (
        <>
          <VideoToolbarSection defaultProps={defaultProps} props={props} initOpen={false} />
          <ImageToolbarSection defaultProps={defaultProps} initOpen={false} />
          <CtaToolbarSection defaultProps={defaultProps} initOpen={false} />
          <LayoutToolbarSection defaultProps={defaultProps} initOpen={false} />
        </>
      )}
    </>
  )
}

export const TextMediaFloatingSettings = () =>
  React.createElement(TextMediaSettings, { floating: true })
